import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-reference-picker-modal',
  templateUrl: './reference-picker-modal.component.html',
  styleUrls: ['./reference-picker-modal.component.css']
})
export class ReferencePickerModalComponent implements OnInit {
  // QuickBooks reference: ids and names are comma separated, same order
  @Input() reference: any;
  @Output() selectId = new EventEmitter<string>();
  @Output() closeModal = new EventEmitter<void>();

  items: { id: string; name: string }[] = [];

  ngOnInit(): void {
    const ids = (this.reference?.id || '').split(',').map((id: string) => id.trim()).filter(Boolean);
    const names = (this.reference?.name || '').split(', ');
    this.items = ids.map((id: string, index: number) => ({ id, name: names.length === ids.length ? names[index] : '' }));
  }
}
